import React, { useState } from "react";
import { CustomButtonsForm } from "../../CustomButtonsForm";
import { useForm, Controller } from "react-hook-form";
import { CustomInputSelect } from "../../CustomInputSelect";
import { CustomInputArea } from "../../CustomInputArea";
import { useOptionsAnswer } from "../../../hooks/encuestas/useOptionsAnswer";
import { CustomInputText } from "../../CustomInputText";
import { CustomInputSwitch } from "../../CustomInputSwitch";
import { convertirLetraMayus } from "../../../helpers/convertirLetraMayus";
import { DynamicsField } from "./DynamicsField";

export const DuplicateQuestionForm = (props) => {

    const { data, action } = props;
    const [activo, setActivo] = useState(data?.activo ? 'Activo' : 'Inactivo');
    const [optionSelected, setOptionSelected] = useState({ nombre: data?.tipo_respuesta?.nombre.toLowerCase(), tipo: '' });
    const { handleSubmit, control, formState: { errors }, unregister, resetField } = useForm();
    const { optionsAnswer } = useOptionsAnswer();

    const renderOptions = () => (
        <DynamicsField 
            data={ data?.tipo_respuesta?.opciones }
            name={ optionSelected }
            controller={ Controller } 
            control={ control }
            resetField={ resetField } 
            errors={ errors } 
            unregister={ unregister }
        />
    );
    
    return (
        <form style={{ margin: '30px 30px 20px 30px', position: 'relative',  width: 450 }} onSubmit={ handleSubmit(action) }>
            <div style={{ maxHeight: 600, overflow: 'scroll' }}>
                <Controller 
                    name='pregunta'
                    control={ control }
                    defaultValue={ convertirLetraMayus(data?.pregunta) || '' }
                    render={({ field: { onChange, value } }) => (
                        <CustomInputArea
                            label="Pregunta"
                            placeholder="abc"
                            error={ errors?.pregunta } 
                            onChange={ onChange }
                            value={ value }
                        />
                    )}
                    
                    rules={{ 
                        required: 'El campo es obligatorio.'
                    }}
                />

                <Controller 
                    name='instrucciones'
                    control={ control }
                    defaultValue={ convertirLetraMayus(data?.instrucciones) || '' }
                    render={({ field: { onChange, value } }) => (
                        <CustomInputArea
                            label="Instrucciones"
                            placeholder="abc"
                            error={ errors?.instrucciones } 
                            onChange={ onChange }
                            value={ value }
                            rows={ 3 }
                        />
                    )}
                />

                <Controller 
                    name='codigo'
                    control={ control }
                    defaultValue=''
                    render={({ field: { onChange, value } }) => (
                        <CustomInputText
                            label="Código único"
                            placeholder=""
                            error={ errors?.codigo } 
                            onChange={ (e) => onChange(convertirLetraMayus(e?.target?.value)) }
                            value={ value }
                        />
                    )}
                    
                    rules={{ 
                        required: 'El campo es obligatorio.',
                        pattern: {
                            value: /^([a-zA-Z]{1}[0-9]{2})+[^\sa-zA-Z]$/,
                            message: "El código no es válido.",
                        }
                    }}
                />

                <Controller 
                    name='nombre'
                    control={ control }
                    defaultValue={ convertirLetraMayus(data?.tipo_respuesta.nombre) || ''}
                    render={({ field: { onChange, value } }) => (
                        <CustomInputSelect
                            label="Tipo de respuesta"
                            placeholder='Seleccione el tipo de respuesta'
                            options={optionsAnswer.map(a => ({ ...a, name: a?.nombre }))}
                            message="Seleccione la opción de respuestas."
                            error={ errors?.nombre } 
                            type='name'
                            onChange={ (e) => {
                                onChange(e);
                                setOptionSelected(() => {
                                    const { nombre, tipo } = optionsAnswer?.find(o => o?.nombre?.toLowerCase().includes(e?.target?.value?.toLowerCase()));
                                    return ({ nombre: nombre.toLowerCase(), tipo: tipo?.toLowerCase()  })
                                });
                                // setOptionSelected(e.target.value?.toLowerCase());
                            }}
                            value={ value }
                        />
                    )}
                    
                    rules={{ 
                        required: 'El campo es obligatorio.',
                        pattern: {
                            value: /^[^\s][a-zA-Z0-9 ].+[^\s]$/,
                            message: "La opción de respuestas no es válido.",
                        }
                    }}
                />

                { renderOptions() }

                <div style={{ display:'flex' }}>
                    <Controller 
                        name='activo'
                        control={ control }
                        defaultValue={ data?.activo || false }
                        render={({ field: { onChange, value } }) => (
                            <CustomInputSwitch
                                label={ activo }
                                onChange={ (e) => {
                                    onChange(e);
                                    e.target.checked ? setActivo('Activo') : setActivo('Inactivo');
                                }}
                                value={ value }
                            />
                        )}
                    />
                </div>
            </div>

            <CustomButtonsForm name='Duplicar' />
        </form>
    );
};